export default __webpack_public_path__ + "static/media/single-border-left.5284cf6c.svg";